import { Shield } from "lucide-react";
export default function Introcommitmentbox() {
  return <section data-section-id="262971" id="introcommitmentbox" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-card border-l-4 border-secondary rounded-lg p-8 md:p-12 lg:p-16 text-left shadow-xl">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-md bg-secondary/10 mb-6">
            <Shield className="w-6 h-6 text-secondary" />
          </div>
          
          <h2 className="text-2xl md:text-3xl font-bold font-default mb-6 text-foreground">
            Our Commitment to Your Privacy
          </h2>
          
          <p className="text-lg md:text-xl font-sans text-muted-foreground max-w-3xl leading-relaxed">
            At BlinkLab Media, we believe that your data is your most valuable asset. Our philosophy is built on a foundation of radical transparency and uncompromising security. We are committed to protecting every byte of user information with industry-leading encryption and ethical data practices, ensuring that your digital footprint remains private, secure, and entirely under your control.
          </p>
        </div>
      </div>
    </section>;
}